import { useMoteTranscriptTranslateMutation, useTrackMutation } from '@mote/api'
import { TRANSLATION_LANGUAGES } from '@mote/helpers/constants'
import React from 'react'

const Comparator = (a, b) => {
  if (a[1] < b[1]) return -1
  if (a[1] > b[1]) return 1
  return 0
}

export const useTranscriptTranslation = (moteId, isCreator, callback) => {
  const { mutate: translate } = useMoteTranscriptTranslateMutation()
  const { mutate: track } = useTrackMutation()

  const translations = React.useMemo(
    () => TRANSLATION_LANGUAGES.sort(Comparator),
    []
  )

  const handleSelection = value => {
    translate({
      variables: {
        moteId,
        translationLanguage: value
      }
    })
      .then(res => {
        if (res.error) return

        track({
          variables: {
            event: 'Translation Generated',
            languageCode: value,
            generatedBy: isCreator ? 'creator' : 'recipient'
          }
        })

        callback(res.data.outputText)
      })
      .catch(console.error)
  }

  return { translations, translate: handleSelection }
}
